import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';

const AppLayout = ({ children }) => {
  const location = useLocation();

  // Routes that should not show the sidebar and header
  const authRoutes = ['/login', '/register', '/guest', '/confirm-email', '/forgot-password'];

  // Check if current route is an auth route
  const isAuthRoute = authRoutes.some(route => location.pathname === route);

  // For auth routes, render children without layout
  if (isAuthRoute) {
    return <>{children}</>;
  }

  // For app routes, render with header and sidebar.
  //
  // The skip link is the first focusable element on the page (task 5.4): the
  // sidebar lists every active course, so without it a keyboard user pays for
  // a dozen-plus tab stops before reaching the content on every navigation.
  // <main> takes tabIndex={-1} so it can receive focus from that link without
  // joining the Tab order itself.
  return (
    <div className="app-container">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <Header />
      <div className="content-container">
        <Sidebar />
        <main id="main-content" className="page-content" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;